import { http } from "@/utils/axios";

/**
 * @msg: 获取准考证学生未考|已考列表
 */
export function getPageByStudentId(data) {
    return http({
        url: http.baseUrl('zkolExamsSeat/getPageByStudentId'),
        method: 'get',
        params: http.params(data)
    })
}